import type { CSSProperties, ReactNode } from 'react';

type MaxWidth = '3xl' | '2xl';

const maxWidthClass: Record<MaxWidth, string> = {
  '3xl': 'max-w-3xl',
  '2xl': 'max-w-2xl',
};

type Props = {
  children: ReactNode;
  /** 見出し列の最大幅（本文カラムに合わせる） */
  maxWidth?: MaxWidth;
  className?: string;
  style?: CSSProperties;
};

/**
 * セクション見出し用ラッパー。container-type: inline-size を付与し、
 * .section-heading の font-size が列幅（cqi）に連動する（index.css 参照）。
 */
export function SectionHeadingContainer({ children, maxWidth = '3xl', className = '', style }: Props) {
  return (
    <div
      className={`section-heading-container mx-auto w-full ${maxWidthClass[maxWidth]} ${className}`.trim()}
      style={style}
    >
      {children}
    </div>
  );
}
